import React from 'react';

/** Sichtbarer Hinweis: HJ1 ist hart gesperrt (auch im Gott-Modus). */
export const Hj1MandantLockBanner: React.FC<{ show: boolean }> = ({ show }) => {
    if (!show) return null;
    return (
        <div
            className="mb-4 px-4 py-3 rounded-xl border border-red-500/50 bg-red-950/40 text-red-100 text-sm font-semibold tracking-wide flex flex-wrap items-center gap-2"
            role="status"
        >
            <span className="uppercase text-[10px] font-black tracking-widest text-red-300 bg-red-500/20 px-2 py-0.5 rounded">
                Gesperrt
            </span>
            <span>
                <strong className="text-red-200">1. Halbjahr ist eingefroren</strong> — auch im Gott-Modus keine
                Änderungen. Nur das 2. Halbjahr ist editierbar.
            </span>
        </div>
    );
};

export default Hj1MandantLockBanner;
